import { useCallback, useMemo, useState } from "react";
import { Popover, Text, Button, Flex } from "@radix-ui/themes";
import { Maximize2 } from "lucide-react";

export function ExpandableText(props: {
  text: string;
  size?: string;
  className?: string;
}) {
  const { text, size = "2", className = "" } = props;
  const [open, setOpen] = useState(false);
  const [hover, setHover] = useState(false);

  const handleOpenChange = useCallback((value: boolean) => {
    setOpen(value);
  }, []);

  const displayText = useMemo(() => {
    if (!text) return "N/A";
    if (text.length > 60) {
      return text.slice(0, 60) + "...";
    }
    return text;
  }, [text]);

  if (!text) return <Text size={size as any}>N/A</Text>;

  return (
    <Popover.Root open={open} onOpenChange={handleOpenChange}>
      <Popover.Trigger>
        <Button
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          variant="ghost"
          size="1"
          className={`p-0 min-w-0 h-auto ${className}`}
          onClick={(e) => {
            e.stopPropagation();
            setOpen(true);
          }}
        >
          <Flex align="center" gap="2" py="1" px="2">
            <Text size={size as any} className="truncate max-w-[480px]">
              {displayText}
            </Text>
            <Maximize2
              className={`w-3 h-3 transition-opacity duration-200 ${
                hover ? " opacity-100" : " opacity-0"
              }`}
            />
          </Flex>
        </Button>
      </Popover.Trigger>
      <Popover.Content side="top" align="start" className="max-w-xs">
        <Flex direction="column" gap="2">
          <div className="max-h-[70vh] overflow-auto">
            <Text
              size={size as any}
              className="break-words whitespace-break-spaces"
            >
              {text}
            </Text>
          </div>
          <Button
            variant="soft"
            size="1"
            color="gray"
            onClick={(e) => {
              e.stopPropagation();
              setOpen(false);
            }}
            className="self-end"
          >
            Close
          </Button>
        </Flex>
      </Popover.Content>
    </Popover.Root>
  );
}
